import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPGalleryLabels from '../PDPGalleryLabels';
import PDPInfoAccordion from '../PDPInfoAccordion';
import PDPMobileConfigurationPhotoGallery from '../PDPMobileConfigurationPhotoGallery';
import PDPMobileGalleryRevamp from '../PDPMobileGalleryRevamp';
import PDPMobileStudioPhotoGallery from '../PDPMobileStudioPhotoGallery';
import PDPSectionDivider from '../PDPSectionDivider';
import PDPCuralateGallery from '../PDPFooter/PDPCuralateGallery';
import { PDPRecentlyViewed } from '../PDPFooter';
import useIsGalleryRevampVariant from '../useIsGalleryRevampVariant';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const PDPMobileRevamp = t0 => {
  const $ = _c(65);
  const {
    discontinuedCategoryMsg: t1,
    isOutOfStock: t2,
    showDiscontinuedNotification: t3,
    showOutOfStockNotification: t4,
    slug,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const isOutOfStock = t2 === undefined ? false : t2;
  const showDiscontinuedNotification = t3 === undefined ? false : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isGalleryRevampVariant = useIsGalleryRevampVariant();
  const {
    isEFGInternal: t8
  } = useProductEFGInternalStatus();
  const isEFGInternal = t8 === undefined ? false : t8;
  const {
    data: optionData
  } = usePDPOptions();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mb-4"><PDPBreadCrumbs /></div>;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== isGalleryRevampVariant || $[4] !== productCylindoHeroImage || $[5] !== productHeroImage || $[6] !== slug) {
    t10 = <div>{isGalleryRevampVariant ? <PDPMobileGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} /> : <PDPMobileStudioPhotoGallery slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} />}</div>;
    $[3] = isGalleryRevampVariant;
    $[4] = productCylindoHeroImage;
    $[5] = productHeroImage;
    $[6] = slug;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  let t12;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FixedWidthContainer><PDPGalleryLabels /></FixedWidthContainer>;
    t12 = <PDPNameSection disableStickyPriceRow={true} hideProductLabel={true} hideRatings={true} />;
    $[8] = t11;
    $[9] = t12;
  } else {
    t11 = $[8];
    t12 = $[9];
  }
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FixedWidthContainer><PDPOnDisplayInShowroom /><hr className="border-0 border-t border-gray-light7 my-6" /></FixedWidthContainer>;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== isOutOfStock || $[12] !== showDiscontinuedNotification) {
    t14 = !isOutOfStock && !showDiscontinuedNotification ? <FixedWidthContainer><PDPShopTabsBar hideDecideLaterTab={true} isLayoutRevamp={true} /></FixedWidthContainer> : <div className="PDPMobileRevamp__PDPShopTabsBar-filler" />;
    $[11] = isOutOfStock;
    $[12] = showDiscontinuedNotification;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== isEFGInternal || $[15] !== isGalleryRevampVariant || $[16] !== optionData?.hasSingleOptionValue || $[17] !== slug) {
    t15 = <ReRenderOnMount>{!isGalleryRevampVariant && (!isEFGInternal || !optionData?.hasSingleOptionValue) ? <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper"><PDPMobileConfigurationPhotoGallery slug={slug} marxentPostHogFlag="test" /></div> : <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper-filler" />}</ReRenderOnMount>;
    $[14] = isEFGInternal;
    $[15] = isGalleryRevampVariant;
    $[16] = optionData?.hasSingleOptionValue;
    $[17] = slug;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== discontinuedCategoryMsg || $[20] !== showDiscontinuedNotification) {
    t16 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPMobile__PDPAlertBar-filler" />;
    $[19] = discontinuedCategoryMsg;
    $[20] = showDiscontinuedNotification;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== isOutOfStock || $[23] !== showDiscontinuedNotification) {
    t17 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPMobile__PDPChooseYourOptions-wrapper"><PDPChooseYourOptions isLayoutRevamp={true} /><PDPProtectionPlanSelector isLayoutRevamp={true} /></div> : <div className="PDPMobile__PDPChooseYourOptions-wrapper-filler" />;
    $[22] = isOutOfStock;
    $[23] = showDiscontinuedNotification;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== isOutOfStock || $[26] !== showDiscontinuedNotification || $[27] !== showOutOfStockNotification) {
    t18 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPMobile__PDPAlertSection-filler" />;
    $[25] = isOutOfStock;
    $[26] = showDiscontinuedNotification;
    $[27] = showOutOfStockNotification;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== showDiscontinuedNotification) {
    t19 = !showDiscontinuedNotification && <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[29] = showDiscontinuedNotification;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== isOutOfStock) {
    t20 = <PDPAddToBagSection isOutOfStock={isOutOfStock} isLayoutRevamp={true} />;
    $[31] = isOutOfStock;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== isOutOfStock || $[34] !== showDiscontinuedNotification) {
    t21 = !isOutOfStock && !showDiscontinuedNotification ? <PDPUpSellProduct /> : <div className="PDPMobileRevamp__add-ons-filler" />;
    $[33] = isOutOfStock;
    $[34] = showDiscontinuedNotification;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t18 || $[39] !== t19 || $[40] !== t20 || $[41] !== t21) {
    t22 = <div>{t16}{t17}{t18}{t19}{t20}{t21}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <PDPKeySellingPoints mobileCarousel={true} />;
    t24 = <PDPInfoAccordion />;
    $[43] = t23;
    $[44] = t24;
  } else {
    t23 = $[43];
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t22) {
    t25 = <FixedWidthContainer>{t22}{t23}{t24}</FixedWidthContainer>;
    $[45] = t22;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== displayPressComp) {
    t26 = !displayPressComp ? <><PDPSectionDivider className="my-8" /><SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} isLayoutRevamp={true} /></SuspenseWithLoader></> : <div className="PDPMobile__PDPPress-filler" />;
    $[47] = displayPressComp;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  let t28;
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <PDPSectionDivider className="my-8" />;
    t28 = <PDPCuralateGallery isLayoutRevamp={true} />;
    t29 = <PDPSectionDivider className="my-8" />;
    $[49] = t27;
    $[50] = t28;
    $[51] = t29;
  } else {
    t27 = $[49];
    t28 = $[50];
    t29 = $[51];
  }
  let t30;
  if ($[52] !== slug) {
    t30 = <PDPCustomerPhotos slug={slug} isLayoutRevamp={true} />;
    $[52] = slug;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <PDPSectionDivider className="my-8" />;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <SuspenseWithLoader><PDPRecentlyViewed isLayoutRevamp={true} /></SuspenseWithLoader>;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== t26 || $[57] !== t30) {
    t33 = <FixedWidthContainer className="max-md:!px-4">{t26}{t27}{t28}{t29}{t30}{t31}{t32}</FixedWidthContainer>;
    $[56] = t26;
    $[57] = t30;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] !== t10 || $[60] !== t14 || $[61] !== t15 || $[62] !== t25 || $[63] !== t33) {
    t34 = <div className="PDPMobileRevamp lg:hidden" data-xc="PDPMobileRevamp">{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t25}{t33}</div>;
    $[59] = t10;
    $[60] = t14;
    $[61] = t15;
    $[62] = t25;
    $[63] = t33;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  return t34;
};
PDPMobileRevamp.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPMobileRevamp;